var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-reseller"},[_vm._v("Reseller screen")])}
var staticRenderFns = []

export { render, staticRenderFns }